export const PKG_NAME = "@hpcc-js/util";
export const PKG_VERSION = "2.46.1";
export const BUILD_VERSION = "2.102.1";
